import { PDF_TYPE, PROVIDER_TYPE } from 'utils/enums';
import {
	IBillsSubBillItem,
	IReceiptResponse,
	IReportPaymentReceiptExtraData,
	IReportPaymentReceiptExtraDataProviderItem,
	IReportPaymentReceiptResponse,
} from 'utils/types';

export const OTHER_PAYMENTS_PROVIDER_TYPES = [PROVIDER_TYPE.PORTMONE, PROVIDER_TYPE.HOSTPAY, PROVIDER_TYPE.MEGOGO];

export const getReportDownloadFileName = (
	data: IReceiptResponse | IReportPaymentReceiptResponse,
	type = PDF_TYPE.RECEIPT
) => {
	let month = '';
	let year = '';
	let id = '';
	if ((data as IReportPaymentReceiptResponse)?.extraData) {
		const extraData: IReportPaymentReceiptExtraData = JSON.parse((data as IReportPaymentReceiptResponse)?.extraData);
		month = extraData.date_DD_MM_YYYY?.slice(3, 5) ?? '';
		year = extraData.date_DD_MM_YYYY?.slice(6) ?? '';
		id = extraData.id?.toString() ?? (data as IReportPaymentReceiptResponse).id.toString();
	} else {
		month = (data as IReceiptResponse).month;
		year = (data as IReceiptResponse).year;
		id = (data as IReceiptResponse).id.toString();
	}
	return `${type}-${month}-${year}-${id}`;
};

export const getReportProviderTotalAmount = (data: IReportPaymentReceiptExtraDataProviderItem[]): number =>
	data.reduce((acc, item) => acc + (item.payed || (item.currentPayed ? +item.currentPayed : 0)), 0);

export const getOtherPaymentsSubBillsByService = (subBills: IBillsSubBillItem[]): IBillsSubBillItem[][] => {
	const map = new Map<string, IBillsSubBillItem[]>();

	subBills.forEach((item) => {
		if (!OTHER_PAYMENTS_PROVIDER_TYPES.includes(item.provider)) {
			return;
		}
		const key = `${item.provider}:${item.serviceId ?? item.id}`;

		const bucket = map.get(key);
		if (bucket) bucket.push(item);
		else map.set(key, [item]);
	});

	return Array.from(map.values());
};

export const getPortmoneSubBillsByService = (subBills: IBillsSubBillItem[]): IBillsSubBillItem[][] =>
	subBills
		.reduce(
			(acc, item) =>
				!acc.includes(item.serviceId as string) && item.serviceId ? [...acc, item.serviceId as string] : acc,
			[] as string[]
		)
		.reduce((acc, item) => {
			const serviceSubBills = subBills.filter((subBillItem) => subBillItem.serviceId === item);
			return serviceSubBills.length ? [...acc, serviceSubBills] : acc;
		}, [] as IBillsSubBillItem[][]);
